import ApiResponseV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/ApiResponseV2";
import HttpClientV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/utils/HttpClientV2";
import { StripeCouponDTO } from "@/models/subscriptions/StripeCouponDTO";
import { SubscriptionInvoice } from "@/models/subscriptions/SubscriptionInvoice";
import { SubscriptionPurchase } from "@/models/subscriptions/SubscriptionPurchase";
import { BuyingFlowSubscriptionPurchaseDTO } from "@/models/subscriptions/SubsctiptionPurchaseDTO";

export interface StripeResponse {
  status: string;
  message: string;
}
class SubscriptionPurchaseService {
  private path: string;
  constructor(path: string) {
    this.path = path;
  }

  // This method gets the user from Core Security in backend
  getActiveByUserAndTenant(tenantExternalId: string): Promise<ApiResponseV2<SubscriptionPurchase>> {
    return HttpClientV2.get(`${this.path}/active/tenant?tenantExternalId=${tenantExternalId}`);
  }

  getActiveByCompany(companyExternalId: string): Promise<ApiResponseV2<SubscriptionPurchase>> {
    return HttpClientV2.get(`${this.path}/active/company?companyExternalId=${companyExternalId}`);
  }

  getSubscriptionInvoicesByTenant(tenantExternalId: string): Promise<ApiResponseV2<SubscriptionInvoice[]>> {
    return HttpClientV2.get(`${this.path}/invoices?tenantExternalId=${tenantExternalId}`);
  }

  getSubscriptionDetailsByTenant(tenantExternalId: string): Promise<ApiResponseV2<any>> {
    return HttpClientV2.get(`${this.path}/details/${tenantExternalId}`);
  }

  getSubscriptionPricesByTenant(tenantExternalId: string): Promise<ApiResponseV2<number>> {
    return HttpClientV2.get(`${this.path}/details/${tenantExternalId}/price`);
  }

  purchaseSubscription(subscriptionPurchaseDTO: BuyingFlowSubscriptionPurchaseDTO): Promise<ApiResponseV2<SubscriptionPurchase>> {
    return HttpClientV2.post(`${this.path}/purchase`, subscriptionPurchaseDTO, {
      axiosConfig: { timeout: 1800000 },
    });
  }

  previewSubscriptionUpdateInvoice(
    subscriptionPurchaseDTO: BuyingFlowSubscriptionPurchaseDTO
  ): Promise<ApiResponseV2<SubscriptionInvoice>> {
    return HttpClientV2.post(`${this.path}/preview/subscription`, subscriptionPurchaseDTO, {
      axiosConfig: {
        timeout: 10000,
      },
    });
  }

  previewDiscountCode(discountCode: string): Promise<ApiResponseV2<StripeCouponDTO>> {
    return HttpClientV2.get(`${this.path}/preview/${discountCode}`, {
      axiosConfig: {
        timeout: 10000,
      },
    });
  }

  cancel(purchaseExternalId: string): Promise<ApiResponseV2<string>> {
    return HttpClientV2.get(`${this.path}/cancel/subscription?externalId=${purchaseExternalId}`);
  }

  enableTrial(companyExternalId: string): Promise<ApiResponseV2<SubscriptionPurchase>> {
    return HttpClientV2.put(`${this.path}/trial?companyExternalId=${companyExternalId}`, {});
  }
}

export default new SubscriptionPurchaseService("/api/subscription-purchase");
